<template>
  <div class="setting">
    <div class="setting-top">
      <div class="setting-top__title">
        汇总周期设置
        <div class="setting-top__tips">(备注：此处可根据您的实际情况按月统一设置所有店铺Listing流量，商品销量，退货量，库存量等的汇总周期) </div>
      </div>
      <div class="setting-top__right">
        店铺员:
        <span class="setting-top__right--value">cb_970818825</span>
      </div>
    </div>
    <tips class="setting-tip">
      <div class="setting-tip__line"> 1. 设置汇总日期的目的是为了按月生成“利润月报表”及继后进行详细的财务分析； </div>
      <div class="setting-tip__line"> 2. 设置汇总日期时请确认是否为公众假期或周末，避免不能及时汇总数据！ </div>
      <div class="setting-tip__line"> 3. 请尽量设置为按每月固定的日期进行汇总,才能更好地进行月统计。 </div>
      <div class="setting-tip__line"> 4. 不在设定的每月汇总日期内，不能上传月汇总数据！ </div>
    </tips>
    <div class="setting-module">
      <div class="setting-module-item">
        <div class="setting-module__title">设置按月汇总日期</div>
        <div class="setting-module-list" v-for="item in summaryTimeList" :key="item.id">
          <div class="setting-module-list__name">{{ item.name }}:</div>
          <el-date-picker
            size="mini"
            :default-value="item.startTime"
            @change="changeDatePicker"
            v-model="item.value"
            :disabled="isDisable"
            placeholder="请选择一个日期"></el-date-picker>
        </div>
      </div>
      <div class="setting-module-item">
        <div class="setting-module__title">已设置汇总周期</div>
        <div class="setting-module-list" v-for="item in setSummaryTimeList" :key="item">
          <div class="setting-module-list__value">{{ item }}</div>
        </div>
      </div>
    </div>
    <div class="setting-bottom">
      <div class="setting-bottom__btn" v-show="isDisable" @click="isDisable = false">修改</div>
      <div class="setting-bottom__btn" v-show="!isDisable" @click="saveBtnClick">保存</div>
    </div>
  </div>
</template>

<script>
import tips from '../common/tips.vue';
import { SummaryNewModule } from './class'
import UserAxios from 'service/user'
export default {
  name: 'summaryDateSetting',
  components: { tips },
  data(){
    return {
      summaryTimeList: SummaryNewModule.NEWSUMMARYTIMEARRAY(),
      /**是否可修改 */
      isDisable: false,
      /**已设置汇总日期 */
      setSummaryTimeList: [],
    }
  },
  methods:{
    changeDatePicker(date){
      let today = new Date()
      let year = today.getFullYear()
      let day = date.Format('dd')
      for(let index in this.summaryTimeList){
        if(day == 31){
          this.summaryTimeList[index].value = new Date(year, Number(index) + 1, 0).Format('yyyy-MM-dd')
        }else if((day == 30 || day == 29) && index == 1){
          this.summaryTimeList[index].value = new Date(year, Number(index) + 1, 0).Format('yyyy-MM-dd')
        }else{
          this.summaryTimeList[index].value = new Date(year, Number(index), day).Format('yyyy-MM-dd')
        }
      }
    },
    /**导入数据 */
    importData(array){
      let startTime, endTime
      return array.map((object, index) => {
        endTime = new Date(object).Format('yyyy-MM-dd')
        if(index === 0){
          startTime = new Date(array[array.length - 1] + 24*60*60*1000).Format('yyyy-MM-dd')
        }else{
          startTime = new Date(array[index - 1]).Format('yyyy-MM-dd')
        }
        return startTime + ' - ' + endTime
      })
    },
    /**设置汇总日期 */
    async setSummaryTime(){
      let data = this.summaryTimeList.map(object => object.value)
      let res = await UserAxios.setSummaryDate(data)
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      this.setSummaryTimeList = this.importData(this.summaryTimeList.map(object => object.value))
      this.$message.success(res.data.info)
      this.isDisable = true
    },
    /**获取已设置的汇总日期 */
    async getSetSummaryTime(){
      let res = await UserAxios.getSummaryDate()
      if(res.data.code !== 1){
        this.$message.error(res.data.info)
        return;
      }
      this.isDisable = true
      let data = res.data.info
      this.setSummaryTimeList = this.importData(data)
      data.map((date, index) => this.summaryTimeList[index].value = date)
    },
    /**保存按钮点击事件 */
    saveBtnClick(){
      let bool = this.summaryTimeList.every(object => object.value)
      if(!bool){
        this.$message.error('请将数据补充完整')
        return;
      }
      this.setSummaryTime()
    }
  },
  created(){
    this.getSetSummaryTime()
  }
}
</script>

<style lang="scss" scoped>
.setting{
  width: 1500px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 10px;
    &__title{
      display: flex;
      align-items: end;
      font-size: 16px;
      color: black;
      font-weight: bold;
    }
    &__tips{
      font-size: 12px;
      font-weight: normal;
      color: #fca605;
    }
    &__right{
      font-size: 12px;
      &--value{
        color: #00a0c7;
      }
    }
  }
  &-module{
    display: flex;
    justify-content: center;
    &__title{
      font-size: 18px;
      font-weight: bold;
      color: #00a0c7;
      text-align: center;
    }
    &-item{
      margin: 10px 100px;
    }
    &-list{
      display: flex;
      align-items: center;
      margin: 10px 0;
      height: 30px;
      line-height: 30px;
      &__name{
        width: 50px;
        text-align: end;
        margin: 0 10px;
      }
    }
  }
  &-bottom{
    display: flex;
    justify-content: end;
    margin: 10px 0;
    &__btn{
      padding: 8px 30px;
      background: #00a0c7;
      color: white;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
